export default __webpack_public_path__ + "/dist/images/image00001.jpeg";